import React from "react";
import { Card, Col, Row } from "react-bootstrap";
import {
  BsBook,
  BsCalendarCheck,
  BsCashCoin,
  BsClock,
  BsPerson,
} from "react-icons/bs";

interface ReservationDetailsCardProps {
  paymentInfo: {
    subjectName: string;
    teacherName: string;
    termDate: Date;
    duration: number;
    price: string;
  };
}

const ReservationDetailsCard: React.FC<ReservationDetailsCardProps> = ({
  paymentInfo,
}) => {
  const formatDate = (date: Date) => {
    return date.toLocaleString("hr-HR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  return (
    <Card className="mb-4 shadow-sm border-0">
      <Card.Header className="bg-primary text-white">
        <h5 className="mb-0">Detalji rezervacije</h5>
      </Card.Header>
      <Card.Body>
        <Row>
          <Col md={6}>
            <div className="d-flex align-items-center mb-3">
              <BsBook className="me-2 text-primary" size={20} />
              <div>
                <div className="text-muted small">Predmet</div>
                <div className="fw-bold">{paymentInfo.subjectName}</div>
              </div>
            </div>

            <div className="d-flex align-items-center mb-3">
              <BsPerson className="me-2 text-primary" size={20} />
              <div>
                <div className="text-muted small">Nastavnik</div>
                <div className="fw-bold">{paymentInfo.teacherName}</div>
              </div>
            </div>
          </Col>
          <Col md={6}>
            <div className="d-flex align-items-center mb-3">
              <BsCalendarCheck className="me-2 text-primary" size={20} />
              <div>
                <div className="text-muted small">Datum i vrijeme</div>
                <div className="fw-bold">
                  {formatDate(paymentInfo.termDate)}
                </div>
              </div>
            </div>

            <div className="d-flex align-items-center mb-3">
              <BsClock className="me-2 text-primary" size={20} />
              <div>
                <div className="text-muted small">Trajanje</div>
                <div className="fw-bold">{paymentInfo.duration} minuta</div>
              </div>
            </div>
          </Col>
        </Row>

        <div className="d-flex align-items-center">
          <BsCashCoin className="me-2 text-primary" size={20} />
          <div>
            <div className="text-muted small">Cijena</div>
            <div className="fw-bold">{paymentInfo.price} EUR</div>
          </div>
        </div>
      </Card.Body>
    </Card>
  );
};

export default ReservationDetailsCard;
